(function () {
  const INIT_FLAG = 'uksgInit';

  function removeEmbeddedStyles(container) {
    if (!container) {
      return;
    }

    container.querySelectorAll(':scope > style').forEach((styleEl) => {
      if (styleEl.textContent.includes('.uksg')) {
        styleEl.remove();
      }
    });
  }

  function scopeInstance(root) {
    if (!root?.classList?.contains('uksg') || root.dataset[INIT_FLAG] === 'true') {
      return;
    }

    root.dataset[INIT_FLAG] = 'true';

    const scope =
      root.dataset.uksgScope ||
      `s${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
    root.dataset.uksgScope = scope;

    removeEmbeddedStyles(root.parentElement);

    const idMap = new Map();
    root.querySelectorAll('[id^="uksg-"]').forEach((element) => {
      const oldId = element.id;
      const newId = `${oldId}--${scope}`;
      idMap.set(oldId, newId);
      element.id = newId;
    });

    root.querySelectorAll('label[for^="uksg-"]').forEach((label) => {
      const oldFor = label.getAttribute('for');
      const mappedFor = idMap.get(oldFor);
      if (mappedFor) {
        label.setAttribute('for', mappedFor);
      }
    });

    root.querySelectorAll('input[type="radio"][name^="uksg-"]').forEach((input) => {
      input.name = `${input.name}--${scope}`;
    });

    const radioGroups = new Set(
      [...root.querySelectorAll('input[type="radio"][name^="uksg-"]')].map((input) => input.name)
    );

    radioGroups.forEach((groupName) => {
      const radios = [...root.querySelectorAll(`input[type="radio"][name="${groupName}"]`)];
      const checkedRadio = radios.find((radio) => radio.hasAttribute('checked')) || radios[0];

      radios.forEach((radio) => {
        radio.checked = radio === checkedRadio;
      });
    });
  }

  function initAll(context = document) {
    context.querySelectorAll('.uksg').forEach(scopeInstance);
  }

  FoxTheme.SizeGuideUksg = {
    init: scopeInstance,
    initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  if (FoxTheme.pubsub?.subscribe && FoxTheme.pubsub?.PUB_SUB_EVENTS?.variantChange) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(() => initAll());
    });
  }

  document.addEventListener('variant:changed', () => {
    requestAnimationFrame(() => initAll());
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) {
          continue;
        }

        if (node.matches?.('.uksg')) {
          scopeInstance(node);
        } else {
          initAll(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
